import { Navigate } from "react-router-dom";

/** Legacy route — investment-only list moved to /invest/requests */
export default function InvestorMyRequestsRedirect() {
  return <Navigate to="/invest/requests?filter=investment" replace />;
}
